export default function getContent(state, componentKey) {
    const content = state.content[componentKey];

    return content?.response?.body?.content?.[0];
}
